<div class="callback-shell">
  <div class="callback-header">
    <h2>Get a Callback</h2>
    <button class="close-button" type="button" aria-label="Close dialog" (click)="close()">×</button>
  </div>
  
  <form (submit)="onSubmit()" class="callback-form">
    <div class="form-group">
      <label for="name">Full Name *</label>
      <input type="text" id="name" name="name" required placeholder="Enter your full name" (input)="name = $event.target.value" />
    </div>

    <div class="form-group">
      <label for="phone">Phone Number *</label>
      <input type="tel" id="phone" name="phone" required placeholder="Enter your phone number" (input)="phone = $event.target.value" />
    </div>

    <div class="form-group">
      <label for="email">Email Address *</label>
      <input type="email" id="email" name="email" required placeholder="Enter your email address" (input)="email = $event.target.value" />
    </div>

    <div class="form-group">
      <label for="message">Message / Details</label>
      <textarea id="message" name="message" rows="4" placeholder="How can we help you?" (input)="message = $event.target.value"></textarea>
    </div>

    <div class="form-actions">
      <button type="button" class="btn-cancel" (click)="close()">Cancel</button>
      <button type="submit" class="btn-submit" [disabled]="!name || !phone || !email">Submit Request</button>
    </div>
  </form>
</div>
